/* eslint-disable indent */
/* eslint-disable camelcase */
import React, { useState, useEffect } from 'react';
import Table from '@techsoftware/happay-widgets/Table';
import PropTypes from 'prop-types';
import Locales from '../../../constants/locales';

const tableActionsIconMap = {
  edit: 'edit',
  view: 'eye-open',
  delete: 'remove',
};

const defaultCurrency = Locales.currency;
function CustomTable(props) {
  // const [state, setState] = useState({
  //   selectedRows: [],
  //   tableData: [],
  //   tooltip: {},
  // });

  const getActionColumnOptions = rowData => {
    const tableActions = [];
    Object.keys(actions).forEach(el => {
      if ((el === 'edit' || el === 'delete') && rowData.editable) {
        tableActions.push({
          key: el,
          // text: actions[el],
          icon: tableActionsIconMap[el],
          tooltip: actions[el],
          action: (cell, col, row, key, event) => {
            event.stopPropagation();
            onClickAction(row, el);
          },
        });
      } else if (el !== 'edit' && el !== 'delete') {
        tableActions.push({
          key: el,
          // text: actions[el],
          icon: tableActionsIconMap[el],
          tooltip: actions[el],
          action: (cell, col, row, key, event) => {
            event.stopPropagation();
            onClickAction(row, el);
          },
        });
      }
    });
    return tableActions;
  };

  useEffect(() => {
    getAllSAvedColumn();
  }, [props.contentType]);

  const {
    headerElements = [],
    data,
    colId,
    // onAmountHover,
    isActionCol,
    actions,
    onClickAction,
    shimmerColumn,
    shimmerRow,
    customTableOuterStyle,
    noContent,
    isDataFetched,
    onRowSelect,
    checkedColumns = [],
    id,
    selectRows,
    selectMultipleRows,
    updateSelectedRows,
    selectedRows = [],
    primaryKey,
    maxRowSelection
  } = props;

  // const { tableData } = state;
  const getAllSAvedColumn = () => {
    if (props?.getColumn && props.enableColumnManagement) {
      const apiParams = {
        content_type: props.contentType,
      };
      props.getColumn(apiParams);
    }
  };

  let tableColumn = [];
  const actionsColumn = [
    {
      Header: '',
      dataField: 'index',
      width: 46,
      isActionCol: true,
      disableDragDrop: true,
      options: row => getActionColumnOptions(row),
    },
  ];
  if (isActionCol) {
    tableColumn = [...headerElements, ...actionsColumn];
  } else {
    tableColumn = headerElements;
  }
  // let defColVal = tableColumn.map((item)=>(item.dataField));
  // console.log(defColVal);
  return (
    <Table
      tableId={id}
      shimmerColumn={shimmerColumn}
      staticRendering
      shimmerRow={shimmerRow}
      customTableOuterStyle={customTableOuterStyle}
      isDataFetched={isDataFetched}
      updateSelectedRows={updateSelectedRows}
      selectMultipleRows={selectMultipleRows}
      selectRows={selectRows}
      dataSort={false}
      data={data}
      columns={tableColumn}
      noDataPlaceHolder={noContent}
      showActionOnRowHover={true}
      showNoMoreItems={props.showNoMoreItems}
      onRowSelect={onRowSelect}
      enableColumnManagement={props.enableColumnManagement}
      handleSaveColumn={props.postAllSavedColumn}
      checkedColumns={checkedColumns}
      selectedRows={selectedRows}
      primaryKey={primaryKey}
      maxRowSelection={maxRowSelection}
    />
  );
}

CustomTable.propTypes = {
  data: PropTypes.array,
  onClickAction: PropTypes.func,
  actions: PropTypes.object,
  headerElements: PropTypes.object,
  //   filterOptions: PropTypes.array,
  colId: PropTypes.string,
  customTableOuterStyle: PropTypes.object,
  noContent: PropTypes.node,
  isActionCol: PropTypes.bool,
  // onAmountHover: PropTypes.func,
  shimmerColumn: PropTypes.number,
  shimmerRow: PropTypes.number,
  isDataFetched: PropTypes.bool,
  showNoMoreItems: PropTypes.bool,
  enableColumnManagement: PropTypes.bool,
  contentType: PropTypes.string,
  checkedColumns: PropTypes.array,
  // onAmountHoverOut: PropTypes.func,
};

CustomTable.defaultProps = {
  colId: [],
  data: [],
  noContent: null,
  isActionCol: true,
  showNoMoreItems: true,
  enableColumnManagement: false,
  checkedColumns: [],
  // onAmountHover: () => {},
  // onAmountHoverOut:()=>{},
};

export default CustomTable;
